import { useRef, useCallback } from 'react';

export const useRingtone = () => {
  const audioCtxRef = useRef(null);
  const oscillatorsRef = useRef([]);
  const intervalRef = useRef(null);
  const isPlayingRef = useRef(false);

  const stopCurrentAudio = useCallback(() => {
    oscillatorsRef.current.forEach(osc => {
      try { osc.stop(); } catch {}
    });
    oscillatorsRef.current = [];
    if (audioCtxRef.current) {
      try { audioCtxRef.current.close(); } catch {}
      audioCtxRef.current = null;
    }
  }, []);

  const stop = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    stopCurrentAudio();
    isPlayingRef.current = false;
  }, [stopCurrentAudio]);

  const play = useCallback(() => {
    if (isPlayingRef.current) return;
    isPlayingRef.current = true;

    const startRing = () => {
      try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)();
        audioCtxRef.current = ctx;

        const gain = ctx.createGain();
        gain.gain.value = 0.25;
        gain.connect(ctx.destination);

        [400, 450].forEach(freq => {
          const osc = ctx.createOscillator();
          osc.type = 'sine';
          osc.frequency.value = freq;
          osc.connect(gain);
          osc.start();
          oscillatorsRef.current.push(osc);
        });

        // Ring for 2s, then fade out for 1s silence before next cycle
        setTimeout(() => {
          gain.gain.setTargetAtTime(0, ctx.currentTime, 0.1);
        }, 2000);
      } catch {}
    };

    startRing();
    // Repeat every 3s: 2s ring + 1s silence
    intervalRef.current = setInterval(() => {
      stopCurrentAudio();
      startRing();
    }, 3000);
  }, [stopCurrentAudio]);

  return { play, stop };
};
